// src/utils/segmentColors.js

/**
 * Utilidad para obtener colores consistentes de segmentos en toda la aplicación
 */

export const getSegmentColor = (segmentName) => {
    const colors = {
        // Segmentos RFM
        'Champions': 'bg-green-100 text-green-800',
        'Loyal Customers': 'bg-blue-100 text-blue-800',
        'At Risk': 'bg-yellow-100 text-yellow-800',
        'Can\'t Lose': 'bg-red-100 text-red-800',
        'About to Sleep': 'bg-orange-100 text-orange-800',
        'Lost': 'bg-gray-100 text-gray-800',

        // Segmentos básicos
        'VIP': 'bg-green-100 text-green-800',
        'Frecuentes': 'bg-orange-100 text-orange-800',
        'Inactivos': 'bg-red-100 text-red-800',
        'Sin Compras': 'bg-gray-100 text-gray-800',
        'Nuevo': 'bg-blue-100 text-blue-800',
        'Ocasional': 'bg-yellow-100 text-yellow-800',
        'Frecuente': 'bg-purple-100 text-purple-800',

        // Segmentos de comportamiento
        'Fin de semana': 'bg-purple-100 text-purple-800',
        'Nocturnos': 'bg-indigo-100 text-indigo-800',
        'Cazapromos': 'bg-pink-100 text-pink-800',
        'Ticket alto': 'bg-emerald-100 text-emerald-800',
        'Express': 'bg-cyan-100 text-cyan-800',
        'Recurrentes': 'bg-teal-100 text-teal-800',
        'Exploradores': 'bg-amber-100 text-amber-800',
        'Especialistas': 'bg-violet-100 text-violet-800',
        'Semanal': 'bg-blue-100 text-blue-800',
        'Quincenal': 'bg-green-100 text-green-800',
        'Mensual': 'bg-orange-100 text-orange-800',
        'Irregular': 'bg-red-100 text-red-800'
    };
    return colors[segmentName] || 'bg-gray-100 text-gray-800';
};

/**
 * Obtiene el color hexadecimal para react-select
 */
export const getSegmentHexColor = (segmentName) => {
    const colors = {
        // Segmentos RFM
        'Champions': '#10B981',
        'Loyal Customers': '#3B82F6',
        'At Risk': '#F59E0B',
        'Can\'t Lose': '#EF4444',
        'About to Sleep': '#F97316',
        'Lost': '#6B7280',

        // Segmentos básicos
        'VIP': '#10B981',
        'Frecuentes': '#F59E0B',
        'Inactivos': '#EF4444',
        'Sin Compras': '#6B7280',
        'Nuevo': '#3B82F6',
        'Ocasional': '#F59E0B',
        'Frecuente': '#8B5CF6',

        // Segmentos de comportamiento
        'Fin de semana': '#8B5CF6',
        'Nocturnos': '#6366F1',
        'Cazapromos': '#EC4899',
        'Ticket alto': '#059669',
        'Express': '#06B6D4',
        'Recurrentes': '#14B8A6',
        'Exploradores': '#F59E0B',
        'Especialistas': '#8B5CF6',
        'Semanal': '#3B82F6',
        'Quincenal': '#10B981',
        'Mensual': '#F97316',
        'Irregular': '#EF4444'
    };
    return colors[segmentName] || '#6B7280';
};

/**
 * Obtiene el icono correspondiente para cada segmento
 */
export const getSegmentIcon = (segmentName) => {
    const icons = {
        // Segmentos RFM
        'Champions': '🏆',
        'Loyal Customers': '💙',
        'At Risk': '⚠️',
        'Can\'t Lose': '🚨',
        'About to Sleep': '😴',
        'Lost': '❌',

        // Segmentos básicos
        'VIP': '⭐',
        'Frecuentes': '🔄',
        'Inactivos': '⏸️',
        'Sin Compras': '🛒',
        'Nuevo': '🆕',
        'Ocasional': '📅',
        'Frecuente': '🔄',

        // Segmentos de comportamiento
        'Fin de semana': '📅',
        'Nocturnos': '🌙',
        'Cazapromos': '🎯',
        'Ticket alto': '💰',
        'Express': '⚡',
        'Recurrentes': '🔄',
        'Exploradores': '🔍',
        'Especialistas': '🎯',
        'Semanal': '📅',
        'Quincenal': '📅',
        'Mensual': '📅',
        'Irregular': '📊'
    };
    return icons[segmentName] || '🏷️';
};

/**
 * Obtiene la descripción del segmento
 */
export const getSegmentDescription = (segmentName) => {
    const descriptions = {
        // Segmentos RFM
        'Champions': 'Clientes de alto valor con alta frecuencia y recencia',
        'Loyal Customers': 'Clientes leales con buena frecuencia de compra',
        'At Risk': 'Clientes valiosos que están reduciendo su actividad',
        'Can\'t Lose': 'Clientes de alto valor en riesgo de perderse',
        'About to Sleep': 'Clientes que han reducido su actividad recientemente',
        'Lost': 'Clientes que no han comprado en mucho tiempo',

        // Segmentos básicos
        'VIP': 'Clientes de muy alto valor',
        'Frecuentes': 'Clientes que compran regularmente',
        'Inactivos': 'Clientes que no han comprado recientemente',
        'Sin Compras': 'Clientes que nunca han realizado una compra',
        'Nuevo': 'Clientes nuevos en el sistema',
        'Ocasional': 'Clientes que compran ocasionalmente',
        'Frecuente': 'Clientes con alta frecuencia de compra',

        // Segmentos de comportamiento
        'Fin de semana': 'Clientes que prefieren comprar los fines de semana',
        'Nocturnos': 'Clientes que compran en horarios nocturnos',
        'Cazapromos': 'Clientes que buscan activamente descuentos y ofertas',
        'Ticket alto': 'Clientes con tamaño promedio de carrito alto',
        'Express': 'Clientes que realizan compras rápidas y frecuentes',
        'Recurrentes': 'Clientes con patrones de compra regulares y predecibles',
        'Exploradores': 'Clientes con alta diversidad de categorías de productos',
        'Especialistas': 'Clientes que concentran su gasto en una categoría específica',
        'Semanal': 'Clientes que compran cada semana',
        'Quincenal': 'Clientes que compran cada dos semanas',
        'Mensual': 'Clientes que compran mensualmente',
        'Irregular': 'Clientes con patrones de compra impredecibles'
    };
    return descriptions[segmentName] || 'Segmento de cliente';
};

/**
 * Obtiene todos los segmentos disponibles organizados por categoría
 */
export const getAllSegments = () => {
    return {
        rfm: [
            'Champions',
            'Loyal Customers',
            'At Risk',
            'Can\'t Lose',
            'About to Sleep',
            'Lost'
        ],
        basic: [
            'VIP',
            'Frecuentes',
            'Inactivos',
            'Sin Compras',
            'Nuevo',
            'Ocasional',
            'Frecuente'
        ],
        behavior: [
            'Fin de semana',
            'Nocturnos',
            'Cazapromos',
            'Ticket alto',
            'Express',
            'Recurrentes',
            'Exploradores',
            'Especialistas',
            'Semanal',
            'Quincenal',
            'Mensual',
            'Irregular'
        ]
    };
};

export default {
    getSegmentColor,
    getSegmentHexColor,
    getSegmentIcon,
    getSegmentDescription,
    getAllSegments
};
